import React from "react";
import { Button, Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

const RecaptchaModal = ({ isOpen, onSuccess, onClose }) => {
  const recaptchaRef = React.createRef();

  const onChange = (value) => {
    onSuccess(value);
  };

  return (
    <>
      <Modal show={isOpen} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-center mb-2">Please complete the reCAPTCHA</p>
          <div className="text-center d-flex flex-column align-items-center">
            <ReCAPTCHA
              ref={recaptchaRef}
              onChange={onChange}
              sitekey="6LdfvmkrAAAAAOcxPsh-gM4qZkeAq7ITqVtUdB3l"
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} className="main-btn btn-filled">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RecaptchaModal;
